import {Component, EventEmitter, Input, Output} from "@angular/core";
import { CommonModule } from "@angular/common";
import {faCaretDown, faChevronLeft, faChevronRight, faFloppyDisk} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";

@Component({
    selector: 'per-page-pagination',
    imports: [CommonModule, FontAwesomeModule, FormsModule],
    templateUrl: './per-page-pagination.component.html'
})
export class PerPagePaginationComponent {
  @Input('currentPagination') currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  @Input('perPageText') perPageText: string = 'Items'
  @Output() currentPaginationChange: EventEmitter<Pagination> = new EventEmitter<Pagination>();
  @Output() perPageFunction = new EventEmitter<Function>()
  @Output() decrementPageFunction = new EventEmitter<Function>()
  @Output() incrementPageFunction = new EventEmitter<Function>()

  perPage(value: string) {
    this.currentPagination.limit = Number(value);
    this.perPageFunction.emit()
  }

  decrementPage() {
    if(this.currentPagination.page !== 0) {
      this.currentPagination.page -= 1;
      this.decrementPageFunction.emit()
    }
  }

  incrementPage() {
    this.currentPagination.page += 1;
    this.incrementPageFunction.emit()
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faCaretDown = faCaretDown;
}
